import { ResourceType } from './resource-type';

/**
 * The resource type for ValueListBrowseDefinition
 *
 * Needs to be in a separate file to prevent circular
 * dependencies in webpack.
 */
export const VALUE_LIST_BROWSE_DEFINITION = new ResourceType('valueList');
